/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetLastVehicleCode,
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    SaveVehicle,
    GetVehicleDetailsByGroupIDOperationEntityID,
    GetVehicleDetailsByVehicleID,
    UpdateVehicle,
    GetBrand,
    GetCapacity,
    GetFuelType,
    GetVehicleOwnership,
    GetPaymentType
};

async function GetLastVehicleCode() {
    const response = await CommonGet('/api/VehicleMaster/GetLastVehicleCode', null);
    return response.data;
}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function SaveVehicle(data) {
    const response = await CommonPost('/api/VehicleMaster/SaveVehicle', null, data);
    return response;
}

async function GetVehicleDetailsByGroupIDOperationEntityID(groupID, operationEntityID) {
    const response = await CommonGet('/api/VehicleMaster/GetVehicleDetailsByGroupIDOperationEntityID', 'groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}


async function GetVehicleDetailsByVehicleID(vehicleID) {
    const response = await CommonGet('/api/VehicleMaster/GetVehicleDetailsByVehicleID', 'vehicleID=' + parseInt(vehicleID));
    return response.data;
}

async function UpdateVehicle(data) {
    const response = await CommonPost('/api/VehicleMaster/UpdateVehicle', null, data);
    return response;
}

async function GetBrand() {
    const response = await CommonGet('/api/VehicleMaster/GetBrand', null);
    return response.data;
}

async function GetCapacity() {
    const response = await CommonGet('/api/VehicleMaster/GetCapacity', null);
    return response.data;
}

async function GetFuelType() {
    const response = await CommonGet('/api/VehicleMaster/GetFuelType', null);
    return response.data;
}

async function GetVehicleOwnership() {
    const response = await CommonGet('/api/VehicleMaster/GetVehicleOwnershipType', null);
    return response.data;
}

async function GetPaymentType() {
    const response = await CommonGet('/api/VehicleMaster/GetVehiclePaymentType', null);
    return response.data;
}